<script lang="ts">
import { breakpointsAntDesign, useBreakpoints } from '@vueuse/core'

export default defineComponent({
  name: 'AppProvider',
  inheritAttrs: false,
  setup(props, { slots }) {
    const breakpoints = useBreakpoints(breakpointsAntDesign)

    const isMobile = computed(() => breakpoints.smaller('md'))
    provide('isMobile', isMobile)

    return () => slots.default?.()
  }
})
</script>
